import { IBetFilters, IBetStats } from '@/types';
import { BetItem } from '@/models/bet';

export const useBetStore = defineStore('bet', () => {
    const items = shallowRef<BetItem[]>([]);
    const total = ref<number>(0);
    const loading = ref<boolean>(false);
    const isExtraFiltersDisplayed = ref<boolean>(false);
    const filters = reactive<IBetFilters>({
        date: null,
        bookmakerId: null,
        botId: null,
        tradingTypeId: null,
        search: '',
        statusId: null,
        marketTypeId: null,
    });

    const stats = reactive<IBetStats>({
        abnormalBetCount: 0,
        balance: '0',
        rejectedBetCount: 0,
        settledBetCount: 0,
        settledStakeSum: '0',
        totalBetCount: 0,
        totalStakeSum: '0',
        totalValidStakeSum: '0',
        unsettledBetCount: 0,
        unsettledStakeSum: '0',
        yield: '0',
    });

    return {
        items,
        total,
        stats,
        loading,
        filters,
        isExtraFiltersDisplayed,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useBetStore, import.meta.hot));
}
